import { atom } from "recoil";

export const authAtom = atom({
  key: 'authAtom',
  default: {
    loggedIn: false,
    loading: true
  },
  dangerouslyAllowMutability: true
})